import { defineComponent as c, watchEffect as u, computed as r, h as i, mergeProps as h } from "vue";
import { useRtl as C } from "./ghl-ui.es823.js";
import g from "./ghl-ui.es912.js";
import { warnOnce as R } from "./ghl-ui.es825.js";
import T from "./ghl-ui.es826.js";
import l from "./ghl-ui.es827.js";
import { useThemeClass as v } from "./ghl-ui.es829.js";
import b from "./ghl-ui.es830.js";
import w from "./ghl-ui.es913.js";
const E = Object.assign(Object.assign({}, l.props), {
  show: {
    type: Boolean,
    default: !0
  },
  appear: Boolean,
  // The collapsed is implemented with mistake, collapsed=true would make it show
  // However there's no possibility to change so I just let it deprecated and use
  // `show` prop instead.
  /** @deprecated */
  collapsed: {
    type: Boolean,
    default: void 0
  }
}), j = c({
  name: "CollapseTransition",
  props: E,
  inheritAttrs: !1,
  setup(e) {
    process.env.NODE_ENV !== "production" && u(() => {
      e.collapsed !== void 0 && R("collapse-transition", "`collapsed` is deprecated, please use `show` instead");
    });
    const {
      mergedClsPrefixRef: t,
      inlineThemeDisabled: n,
      mergedRtlRef: a
    } = T(e), d = l("CollapseTransition", "-collapse-transition", g, w, e, t), f = C("CollapseTransition", a, t), m = r(() => e.collapsed !== void 0 ? e.collapsed : e.show), o = r(() => {
      const {
        self: {
          bezier: p
        }
      } = d.value;
      return {
        "--n-bezier": p
      };
    }), s = n ? v("collapse-transition", void 0, o, e) : void 0;
    return {
      rtlEnabled: f,
      mergedShow: m,
      mergedClsPrefix: t,
      cssVars: n ? void 0 : o,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    return i(b, {
      appear: this.appear
    }, {
      default: () => {
        var e;
        if (this.mergedShow)
          return (e = this.onRender) === null || e === void 0 || e.call(this), i(
            "div",
            // Don't use jsx since it would cause useless spread in each rendering
            h({
              class: [`${this.mergedClsPrefix}-collapse-transition`, this.rtlEnabled && `${this.mergedClsPrefix}-collapse-transition--rtl`, this.themeClass],
              style: this.cssVars
            }, this.$attrs),
            this.$slots
          );
      }
    });
  }
});
export {
  E as collapseTransitionProps,
  j as default
};
